__turbopack_context__.v({
  "learnLabel": "NavigationLogo-module-scss-module__axKgSG__learnLabel",
  "learnLabelLink": "NavigationLogo-module-scss-module__axKgSG__learnLabelLink",
  "logoWrapper": "NavigationLogo-module-scss-module__axKgSG__logoWrapper",
  "siteLabel": "NavigationLogo-module-scss-module__axKgSG__siteLabel",
});
